import { initialState } from "../store/initialState";
import { AnyAction } from "redux";
import { internalActionKeys } from "../actions/internalActionKeys";
import { ReportDto } from "../types/report";

export default function appointmentsListReportReducer(
  state: ReportDto = initialState.appointmentsListReport,
  action: AnyAction
): ReportDto {
  switch (action.type) {
    case internalActionKeys.GET_APPOINTMENTS_LIST_REPORT_SUCCESS:
      return action.report;
    default:
      return state;
  }
}
